import lightOrdarkColor from "@check-light-or-dark/color";
import { darken, lighten, Tooltip } from "@mui/material";

const TooltipComponent = ({ title, children, theme, placement }: any) => {
    return (<Tooltip
        title={
            <span style={{ fontWeight: 400 }}>{title}</span>
        }
        placement={placement || 'right'}
        arrow={false}
        componentsProps={{
            tooltip: {
                sx: {
                    borderRadius: '4px',
                    backgroundColor: lightOrdarkColor(theme.palette.background.default) === 'dark' ? lighten(theme.palette.background.default, 0.2) : darken(theme.palette.background.default, 0.7),
                    color: theme.palette.text.contrastText,
                    fontSize: '1rem',
                    fontWeight: 400,
                    padding: '4px 16px',
                    position: 'relative',
                    // height: '32px',
                    display: 'flex',
                    alignItems: 'center',
                    marginLeft: '12px', // space for arrow          
                    '&::before': {
                        content: '""',
                        position: 'absolute',
                        left: '-12px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        width: 0,
                        height: 0,
                        borderTop: '10px solid transparent',
                        borderBottom: '10px solid transparent',
                        borderRight: `12px solid ${lightOrdarkColor(theme.palette.background.default) === 'dark' ? lighten(theme.palette.background.default, 0.2) : darken(theme.palette.background.default, 0.7)}`,
                    },
                },
            },
        }}
    >
        {children}
    </Tooltip>
    )
};

export default TooltipComponent;